/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DataTable from "examples/Tables/DataTable";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDButton from "components/MDButton";
import CustomAlert from "components/CustomAlert";

// Data
import { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useMaterialUIController, setLoading } from "context";
import TableSkeleton from "components/TableSkeleton";
import { ParameterAPI } from "api/ParameterAPI";
import permissions from "permissions";


export default function ListParameters() {
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState('');
  const [alertColor, setAlertColor] = useState('info');
  const [controller, dispatch] = useMaterialUIController();
  const [parameters, setParameters] = useState([]);
  const { user, loading } = controller;
  const location = useLocation();
  const message = location.state;


  const renderTable = useMemo(() => {

    let rows = [];
    const columns = [
      { Header: "Parametro", accessor: "parametro", align: "left" },
      { Header: "Valor", accessor: "valor", align: "left" },
      { Header: "Observaciones", accessor: "observaciones", align: "left" },
      { Header: "Sugerencia", accessor: "sugerencia", align: "left" },
      { Header: "acción", accessor: "action", align: "center" },
    ];

    parameters.map((element) => {
      rows = [...rows,
      {
        parametro: element.parametro,
        valor: element.valor,
        observaciones: element.observaciones,
        sugerencia: element.sugerencia,
        action: (
          <MDBox>
            {(user?.permissions?.includes('parameter-edit') || user?.role === 'admin') && (
              <IconButton component={Link} aria-label="edit" value={element.id} to={element.id + '/edit'}>
                <EditIcon />
              </IconButton>
            )}
          </MDBox>
        ),
      }
      ]
    });

    return (<DataTable
      table={{ columns, rows }}
      isSorted={true}
      entriesPerPage={true}
      showTotalEntries={true}
      noEndBorder
      canSearch={true}
    />
    )
  }, [parameters])

  const handleAlert = (content, color) => {
    setAlertContent(content);
    setAlertColor(color);
    setAlert(true)
  }

  const handleAlertClose = () => {
    setAlert(false);
  }

  useEffect(() => {
    if (message) {
      handleAlert(message, 'success');
    }
  }, [message]);

  const getParameters = (signal) => {
    return ParameterAPI.index(signal)
      .then(response => {
        setParameters(response.parameters)
        console.log(response.parameters)
      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        setLoading(dispatch, false)
      });
  }

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    setLoading(dispatch, true)
    window.history.replaceState({}, document.title)
    getParameters(signal);

    return () => {
      abortController.abort();
    };
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12} lg={12}>
            <MDBox mb={4} px={2}>
              <CustomAlert severity={alertColor} message={alertContent} open={alert} onClose={handleAlertClose}></CustomAlert>
            </MDBox>
            <Card>
              <MDBox>
                {loading ? <TableSkeleton></TableSkeleton> : renderTable}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}










